import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseHttpService } from './base.http.service';
import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app.config';
import {IPortfolio} from "../../models/portfolios";
import { IEnvironmentConfig } from 'src/app/models/environmentConfig';
import { IMemberViewModel } from 'src/app/models/memberViewModel';

@Injectable()
export class InvestorService extends BaseHttpService {
    constructor(private http: HttpClient, private appConfig: AppConfig) {
        super();
    }
    
    get envSettings(): IEnvironmentConfig {
        return this.appConfig.getEnvironmentConfig();
    }

    public getInvestorReferenceNumber(investorEntityId: number): Observable<any> {
        const url = `${this.envSettings.webApiUrl}investorentity/referencecode/${investorEntityId}`;
        return this.http.get(url, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public getInvestorDetails(investorEntityId: string): Observable<any> {
        const url = `${this.envSettings.webApiUrl}investorEntity/${investorEntityId}`;
        return this.http.get(url, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public saveInvestorDetails(investorDetails: any, investorEntityId: string): Observable<any> {
        const url = `${this.envSettings.webApiUrl}investorEntity/${investorEntityId}`;
        const jsonBody = JSON.stringify(investorDetails);
        return this.http.patch(url, jsonBody, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public getInvestorsAdvisorInformation(investorEntityIds: number[]): Observable<any>{
        const queryString = investorEntityIds.join('&investorEntityIds=');
        const url = `${this.envSettings.webApiUrl}investorEntity/advisorInformation?investorEntityIds=` + queryString;
        return this.http.get(url, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public getInvestorPortfolios(investorEntityId: number): Observable<IPortfolio[]> {
      let url = new URL(`${this.envSettings.webApiUrl}investorEntity/${investorEntityId}/portfolios`);

      return this.http.get<IPortfolio[]>(url.toString(), {
        observe: 'body',
        responseType: 'json',
        headers: this.getHttpHeaders()
      });
    }

    public getInvestorMembers(investorEntityId: number): Observable<IMemberViewModel[]> {
        let url = new URL(`${this.envSettings.webApiUrl}investorentity/${investorEntityId}/members`);

        return this.http.get<any[]>(url.toString(), {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
          });
    }
}
